<template>
  <div class="flex sharing-v">
    <Header />
    <Step />
    <div class="wrapper">
      <div class="avatar-box flex sharing-v" style="align-items: center">
        <img
          width="200"
          :src="avatarUrl"
          alt
          v-if="avatarUrl && avatarUrl != 'null'"
        />
        <img width="200" alt src="@/assets/images/avatar.png" v-else />
        <a-upload
          name="file"
          accept="image/*"
          action="3131"
          :beforeUpload="beforeUpload"
          :showUploadList="false"
          @change="photoHandleChange"
        >
          <a-button type="primary" inline-block style="margin: 20px 0">
            <a-icon type="loading" v-if="loading" />上传照片
          </a-button>
        </a-upload>
        <span style="color: #1890ff; margin: 20px"
          >照片要求：2寸蓝底免冠证件照，该照片将用于准考证及证书</span
        >
      </div>
    </div>
    <a-form-item class="text-center">
      <a href="/area"
        ><a-button type="detault" inline-block style="margin-right: 20px"
          >上一步</a-button
        ></a
      >
      <a-button
        type="primary"
        @click="nextStep"
        inline-block
        class="login-form-button"
        >下一步</a-button
      >
    </a-form-item>
  </div>
</template>

<script>
// function getBase64(img, callback) {
//   const reader = new FileReader();
//   reader.addEventListener("load", () => callback(reader.result));
//   reader.readAsDataURL(img);
// }

// @ is an alias to /src
import Header from "../components/Header";
import Step from "../components/common/step";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("apply");
export default {
  name: "Login",
  components: {
    Header,
    Step
  },
  data() {
    return {
      loading: false,
      avatarUrl: "",
      avatarFile: null
    };
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
    this.getStudentInfo({
      orderCode: userInfo.orderCode,
      userCode: userInfo.userCode,
      examCode: userInfo.examCode,
    }).then(res => {
      let studentInfo = res.data;
      if (studentInfo.status == '2000') {
        this.avatarUrl = studentInfo.data.enrollImageURL;
        this.userInfo = studentInfo.data;
      } else {
        this.userInfo = userInfo;
      }
    });
  },
  methods: {
    ...mapActions(["updateStudentAction", "getStudentInfo", "getPicUrl"]),
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("文件格式为jpg、png!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isSm200k = file.size / 1024 > 200;
      if (!isLt2M) {
        this.$message.error("图片大小不大于2M!");
      }
      if (!isSm200k) {
        this.$message.error("图片大小不小于200k!");
      }
      return isJPG && isLt2M && isSm200k;
    },
    photoHandleChange(info) {
      this.avatarFile = info.file.originFileObj;
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      } else {
        let formData = new FormData();
        formData.append("file", info.file.originFileObj);
        this.getPicUrl(formData).then(res => {
          if (res.data.status == 2000) {
            this.avatarUrl = res.data.data;
          }

        });
        // getBase64(info.file.originFileObj, imageUrl => {
        //   this.avatarUrl = imageUrl;
        this.loading = false;
        // });
      }
    },
    nextStep() {
      console.log(this.avatarUrl)
      if (this.avatarUrl == "" || this.avatarUrl == "null" || this.avatarUrl == null) {
        this.$warning({
          title: "注意",
          content: "请上传头像",
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
          onOk() {
            console.log("OK");
          },
          onCancel() {
            console.log("Cancel");
          }
        });
        return;
      }
      let values = {};
      let userInfo = JSON.parse(localStorage.getItem("studentInfo"));
      values.enrollInfoId = userInfo.enrollInfoId;
      values.examCode = userInfo.examCode;
      values.enrollImageURL = this.avatarUrl;
      values.updateType = 4;

      let formData = new FormData();
      // fields 是表單內容，將它 append 到 formData
      Object.keys(values).map(item => {
        formData.append(item, values[item]);
      });
      this.updateStudentAction(formData).then(res => {
        this.applyStatusJudge(res.data);
      });
    },
    applyStatusJudge(data) {
      if (data.status == 2000) {
        this.$router.push("/phone");
      } else {
        this.$warning({
          title: data.message,
          content: data.message,
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
          onOk() {
            console.log("OK");
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.row-item {
  margin-top: 15px;
}
.form-title {
  margin-bottom: 15px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}
.form-item {
  align-items: flex-start;
}
.avatar-box {
  margin-top: 50px;
}
.avatarImg {
  background: url("../assets/images/avatar.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>